module.exports = __webpack_public_path__ + "static/recipe2-2260676f9913f91a53c5ef55ac30035f.svg";